

import React, { useState, useEffect, useRef } from 'react';
import FloatingButton from './FloatingButton'; 
import Logo from '../components/Logo'; 

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [conocenosOpen, setConocenosOpen] = useState(false);
  const [utilesOpen, setUtilesOpen] = useState(false);
  const [galeriaOpen, setgaleriaOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  
  const navbarRef = useRef(null);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const toggleConocenos = () => setConocenosOpen(!conocenosOpen);
  const toggleGaleria = () => setgaleriaOpen(!galeriaOpen);
  const toggleUtiles = () => setUtilesOpen(!utilesOpen);

  const closeMenu = () => {
    setMenuOpen(false);
    setConocenosOpen(false);
    setUtilesOpen(false);
    setgaleriaOpen(false);
  };

  const handleReservarClick = () => {
    setIsModalOpen(true);
  };

  const handlePasswordSubmit = (e) => {
    e.preventDefault();
    if (password === 'ENZ8593') {
      window.open(
        'https://sites.google.com/nzelandia.cl/centro-de-innovacion/inicio?pli=1&authuser=1', 
        '_blank'
      );
      setPassword('');
      setErrorMessage('');
      setIsModalOpen(false);
    } else {
      setErrorMessage('Clave incorrecta, por favor intente nuevamente.');
      setPassword('');
      setIsModalOpen(false);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navbarRef.current && !navbarRef.current.contains(event.target)) {
        closeMenu();
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <nav className={`navbar ${menuOpen ? 'abierto' : ''}`} ref={navbarRef}>
      <div className="logo-container">
        {/* <Logo /> */}
      </div>
      <div className="hamburguesa" onClick={toggleMenu}>
        <div className="barra"></div>
        <div className="barra"></div>
        <div className="barra"></div>
      </div>
      <ul className={`menu ${menuOpen ? 'abierto' : ''}`}>
        <li><a href="#inicio" onClick={closeMenu}>Inicio</a></li>
        <li><a href="#events-component" onClick={closeMenu}>Informaciones</a></li>
        <li className={`dropdown ${conocenosOpen ? 'abierto' : ''}`}>
          <a href="#" onClick={toggleConocenos}>Conócenos</a>
          <ul className={`submenu ${conocenosOpen ? 'abierto' : ''}`}>
            <li><a href="#QuienesSomos" onClick={closeMenu}>Quiénes Somos</a></li>
            <li><a href="#personal-establecimiento" onClick={closeMenu}>Personal Establecimieto</a></li>
            <li><a href="#nuestra-mision-component" onClick={closeMenu}>Nuestra Misión</a></li>
            <li><a href="#vision-component" onClick={closeMenu}>Visión</a></li>
            <li><a href="#sellos-component" onClick={closeMenu}>Sellos</a></li>
            <li><a href="#valores-component" onClick={closeMenu}>Valores</a></li>
          </ul>
        </li>

        <li className={`dropdown ${galeriaOpen ? 'abierto' : ''}`}>
          <a href="#" onClick={toggleGaleria}>Galerías & Trabajos</a>
          <ul className={`submenu ${galeriaOpen ? 'abierto' : ''}`}>
            <li><a href="#cuadrohonor-component" onClick={closeMenu}>Cuadro de Honor</a></li> 
            <li><a href="#licenciados-component" onClick={closeMenu}>Licenciados & Graduados</a></li> 
            <li><a href="#videos-container" onClick={closeMenu}>Galería Audiovisual</a></li>
            <li><a href="#Instagram-list" onClick={closeMenu}>Galería Instagram</a></li>
                   
            <li><a href="https://padlet.com/g4pzjdvh65/talleres-jec-de-artes-dggvfttlwwonztsd" target="_blank" rel="noopener noreferrer" onClick={closeMenu}>Galería de Arte</a></li>
           
            <li><a href="#biblioteca-cra-component" onClick={closeMenu}>Bliblioteca Cra</a></li>
          </ul>
        </li>

        <li><a href="#proyecto-container" onClick={closeMenu}>Proyectos</a></li>
        <li><a href="#documentos" onClick={closeMenu}>Documentos Institucionales</a></li>
        <li><a href="#Listajunaeb" onClick={closeMenu}>Alimentación Junaeb</a></li>
        <li><a href="#listacursos" onClick={closeMenu}>Útiles Escolares Año 2026</a></li>
        
        <li>
          <a href="#" onClick={handleReservarClick} title="">
            Reservar
          </a>
        </li>
        
        <li><a href="#contacto" onClick={closeMenu}>Contacto</a></li>
        <FloatingButton />
      </ul>

      {/* Modal */}
      {isModalOpen && (
        <div className="modal">
          <div className="modal-content">
            <h2>Ingrese la clave</h2>
            <form onSubmit={handlePasswordSubmit}>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Clave de acceso"
              />
              <button type="submit">Acceder</button>
            </form>
            {errorMessage && <p className="error">{errorMessage}</p>}
            <button onClick={() => setIsModalOpen(false)}>Cerrar</button>
          </div>
        </div>
      )}

      {/* 🎨 Estilos */}
      <style jsx>{`
        :root {
          --fondo-submenu: rgba(40, 85, 153, 0.55);
        }

        .navbar {
          list-style: none;
          display: flex;
          justify-content: space-between;
          align-items: center;
          background-color: #285599;
          padding: 1rem;
          border-bottom: 3px solid red;
          border-top: 3px solid red;
          background: linear-gradient(to bottom, #285599, #002a5c);
          position: relative;
          top: -80px;
          z-index: 2000; /* ✅ Se superpone sobre el carrusel */
        }

        .logo-container {
          display: flex;
          align-items: center;
        }

        .hamburguesa {
          display: none;
          cursor: pointer;
        }

        .barra {
          width: 30px;
          height: 3px;
          background-color: white;
          margin: 6px 0;
        }

        .menu {
          display: flex;
          list-style: none;
          margin: 0;
          padding: 0;
          z-index: 2001; /* ✅ Asegura que esté encima */
          position: relative;
        }

        .menu li {
          margin: 0 1rem;
          position: relative;
        }

        .menu a {
          text-decoration: none;
          color: white;
          position: relative;
        }

        .menu a:hover {
          color: white;
        }

        .menu a::after {
          content: "";
          display: block;
          width: 0;
          height: 2px;
          background: #00ffff;
          transition: width 0.3s;
          position: absolute;
          bottom: -5px;
          left: 0; 
        }

        .menu a:hover::after {
          width: 100%;
        }

        /* 🎯 SUBMENÚS */
        .submenu {
          display: none;
          list-style: none;
          position: absolute;
          top: 100%;
          left: 0;
          background: var(--fondo-submenu);
          backdrop-filter: blur(10px);
          -webkit-backdrop-filter: blur(10px);
          padding: 0.8rem;
          z-index: 2002; /* ✅ Submenú encima del carrusel */
          opacity: 0;
          transition: opacity 0.3s ease;
          border-radius: 10px;
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
        }

        .dropdown:hover .submenu {
          display: block;
          opacity: 1;
        }

        .submenu li {
          margin: 0.5rem 0;
          padding: 4px;
        }

        .submenu a {
          text-decoration: none;
          color: white;
          display: block;
        }

        @media (max-width: 768px) {
          .hamburguesa {
            display: block;
          }

          .menu {
            display: none;
            position: absolute;
            top: 200px;
            right: 0;
            background-color: #285599;
            width: 100%;
            text-align: center;
            z-index: 2001;
          }

          .menu.abierto {
            display: flex;
            flex-direction: column;
          }

          .menu li {
            margin: 1rem 0;
          }

          .dropdown:hover .submenu {
            display: block;
            opacity: 1;
          }
        }

        @media (min-width: 769px) {
          .menu {
            position: relative;
            top: 0;
          }

          .menu.abierto {
            display: flex;
            flex-direction: row;
            background: transparent;
            width: auto;
          }

          .menu li {
            margin: 0 1rem;
          }

          .dropdown:hover .submenu {
            display: block;
            opacity: 1;
          }
        }

        /* Modal */
        .modal {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.5);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 3000; /* ✅ Siempre sobre todo */
        }

        .modal-content {
          background-color: white;
          padding: 20px;
          border-radius: 8px;
          width: 300px;
          text-align: center;
        }

        input {
          margin-bottom: 10px;
          padding: 8px;
          width: 100%;
          border: 1px solid #ccc;
          border-radius: 4px;
        }

        button {
          padding: 10px 20px;
          background-color: #285599;
          color: white;
          border: none;
          border-radius: 4px;
          cursor: pointer;
        }

        button:hover {
          background-color: #003366;
        }

        .error {
          color: red;
          margin-top: 10px;
        }
      `}</style>
    </nav>
  );
}

export default Navbar;
